<template>
  <div class="video-detail">
    <!-- 畅学卡购买 -->
    <!--<div class="buy-card-btn-v" v-if="!isPrivilege" @click="hideBtn(buyCard)" ref="buyCard">-->
      <!--<img src="../assets/images/buycardbtn.png" alt="">-->
      <!--<span @click="goto">365天免费学</span>-->
    <!--</div>-->

    <!--v-show用以解决安卓浏览器遮挡问题-->
    <video-controller
      v-show="!comment.popup.show"
      :src="data.mediaUrl"
      :img="data.chapterImage"
      :played-time="data.playLength"
      :length="data.mediaLength"
      :is-ios="isWpsIos"
      @error="videoError"
    />

    <!-- 提示弹窗 -->
    <!-- <notice v-show="clockInStatus.isSendNotify === 0&&!isApp&&clockInStatus.isSignCourse === 1 && !clockInStatus.encourageType" ref="notice">
      <div class="video-detail-notice" v-if="clockInStatus.encourageType === 2">
        <h1>打卡规则</h1>
        <h5>尊敬的学员，课程上线打卡返学费功能，每天学习后打卡分享至朋友圈，即可全额返学费</h5>
        <p><i class="video-detail-notice-index">1</i>学费以代金券的形式返还，代金券全场通用</p>
        <p><i class="video-detail-notice-index">2</i>之前学习的章节可以补打卡，全部补完后即可返还学费。</p>
        <div @click="closeNotice" class="video-detail-notice-btn">知道了</div>
      </div>
      <div class="video-detail-notice" v-if="clockInStatus.encourageType === 1">
        <h1>打卡规则</h1>
        <h5>尊敬的学员，课程上线打卡返红包功能</h5>
        <p><i class="video-detail-notice-index">1</i>每天学习后打卡分享至朋友圈，即可领取现金红包！</p>
        <p><i class="video-detail-notice-index">2</i>一天最多可返一次哦！</p>
        <div @click="closeNotice" class="video-detail-notice-btn">知道了</div>
      </div>
    </notice> -->

    <!-- 评论条 -->
    <comment-bar
      v-if="totalCommentList.length"
      :quantity="totalCommentList.length"
      @comment="toggleCommentPopup"
    />

    <!-- 回复浮层 -->
    <reply-popup
      v-if="comment.popup.show"
      v-model="comment.popup.content"
      :placeholder="comment.popup.placeholder"
      :cancel="toggleCommentPopup"
      :send="sendOneComment"
    />

    <!-- 评论 -->
    <div v-if="totalCommentList.length" class="video-detail-comment">
      <comment-box
        v-for="item in totalCommentList"
        :key="item.id"
        :comment="item"
      />
      <div style="height: 100px;" />
    </div>

    <!-- 没有评论的情况 -->
    <div v-else class="video-detail-comment placeholder">
      <img src="../assets/images/comment-placeholder.png" alt="comment"/>
      <p>快来和老师分享学习心得吧~</p>
      <button @click="toggleCommentPopup">写留言</button>
    </div>

    <!-- 底部条 -->
    <!-- <DetailBottom
      v-if="!is1yuan"
      :is-clock="clockInStatus.isSign === 1"
      :hasBuy="hasBuy"
      :data-source="data"
      :isBottomShow="isBottomShow">
    </DetailBottom> -->

    <!-- 二维码浮层 -->
    <!-- <notice class="weixin-notice" ref="weixin" :closeBtn="true" width="530" height="520">
      <div class="weixin-notice-main">
        <h1>扫码下方小程序立即提问</h1>
        <img src="//cdn.iciba.com/www/img/edu-m/question-code.jpeg" alt="">
        <img  class="weixin-notice-main-code" src="//cdn.iciba.com/www/img/edu-m/question-code.jpeg" alt="">
        <p>长按识别小程序码</p>
      </div>
    </notice> -->

    <!-- 显示提问二维码 -->
    <div class="video-detail-packet" v-if="!isApp && data.canAsk">
      <div class="video-detail-packet-close" @click="data.canAsk = !data.canAsk">x</div>
      <img @click="$refs.weixin.show()" :src="data.askIcon" alt="">
    </div>

    <!-- 1元课打开按钮 -->
    <div class="bottom" v-if="is1yuan">
      <!-- data.promoteCourseSignStatus 0:未打卡 1:已打卡 2:已过有效期 -->
      <template v-if="data.promoteCourseSignStatus === 0">
        <div class="bottom-tip">点击播放后才能进行打卡喔~</div>
        <UIButton width="690" @click="gotoClock">打卡</UIButton>
      </template>
      <UIButton v-else-if="data.promoteCourseSignStatus === 1" width="690" disabled>本节已成功打卡！</UIButton>
      <UIButton v-else-if="data.promoteCourseSignStatus === 2" width="690" disabled>此节打卡已超过有效期</UIButton>
    </div>
  </div>
</template>

<script>
  import os from '@edu-fe/os'
  import keys from 'lodash.keys'
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

  import module from '../modules/video-detail'
  import moduleComment from '../modules/comment'
  import ShareMaker from '../lib/shareMaker'
  import { isxxx } from '../mixins'
  // import Notice from '../components/Notice'
  import ClockIn from '../components/ClockIn'
  import UIButton from '../components/UI/Button'
  import VideoController from '../components/VideoController'
  // import DetailBottom from '../components/Detail/DetailBottom'
  import { CommentBox, CommentBar, ReplyPopup } from '../components/Comment'
  import record, { clearTimer } from '../lib/record'
  const moduleCommentPath = `${module.name}/${moduleComment.name}`

  export default {
    components: {
      VideoController,
      CommentBox,
      CommentBar,
      ReplyPopup,
      ClockIn,
      // Notice,
      // DetailBottom,
      UIButton
    },

    computed: {
      ...mapState(module.name, keys(module.state())),
      ...mapState(module.name, keys(module.modules)),
      ...mapGetters(module.name, keys(module.getters)),
      ...mapGetters(moduleCommentPath, keys(moduleComment.getters)),
      ...mapState(['isPrivilege', 'userInfo']),

      buyCard() {
        return this.$refs.buyCard
      },

      courseId () {
        return this.$route.query.courseId
      },

      // 是否是1元课
      is1yuan () {
        return os.type === 'weixin' && this.hasBuy && this.data.isPromote === 1
      }
    },

    mixins: [
      isxxx
    ],

    methods: {
      ...mapMutations(module.name, keys(module.mutations)),
      ...mapMutations(moduleCommentPath, keys(moduleComment.mutations)),
      ...mapActions(module.name, keys(module.actions)),
      ...mapActions(moduleCommentPath, keys(moduleComment.actions)),

      // closeNotice() {
      //   this.$refs.notice.close()
      // },

      goto () {
        setTimeout(()=>{
          this.$router.push('/vip?from=H5_VIP')
        },300)
      },

      // 去往1元课程打卡页面
      gotoClock () {
        this.$router.push({
          name: 'clock-schedule',
          query: {
            chapterId: this.data.chapterId,
            courseId: this.data.courseId
          }
        })
      },

      toActivityPage () {
        window.location.href = `https://edu-activity.wps.cn/activity/pull-new?courseId=${this.courseId}&from=laodaixin-gif`
      }
    },
    beforeRouteLeave (to, from, next) {
      clearTimer()
      next()
    },
    beforeCreate () {
      this.$store.registerModule(module.name, module)
    },

    created () {
      this.init(this)
    },

    mounted () {
      // this.$nextTick(() => this.$refs.notice.show())

      // console.log(this)
    },

    beforeDestroy () {
      this.$store.unregisterModule(module.name)
    },

    watch: {
      data (data) {
        // window.history.replaceState({}, document.title, this.landingPage)
        const href = `${location.protocol}//${location.host}${this.$route.fullPath}`
        setTimeout(() => {
          // return new ShareMaker(Object.assign(data, { userId: this.userInfo.userId }), href)
          return new ShareMaker({
            title: '微课',
            introduction: data.courseName || data.chapterTitle,
            imgUrl: 'https://staticedu.wps.cn/static_file/pictures/watermark/logo.jpg',
            link: window.location.href
          }, href, true)
        }, 300);
      }
    }
  }
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.video-detail {
  .weixin-notice {
    &-main{
      position: relative;
      padding: rem(60);
      img {
        width: rem(240);
      }
      &-code {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        z-index: 1;
      }
      h1 {
        font-size: rem(36);
        color: #333333;
        font-weight: bold;
        margin-bottom: rem(40);
      }
      p {
        font-size: rem(28);
        margin-top: rem(40);
        color: #999999;
      }
    }
  }

  &-packet {
    position: fixed;
    bottom: rem(146);
    right: rem(20);
    &-close {
      font-size: rem(20);
      width: rem(24);
      height: rem(24);
      line-height: rem(24);
      text-align: center;
      border-radius: 100%;
      color: #999999;
      border: 1px solid #999999;
      position: absolute;
      right: rem(-10);
      top: rem(-10);
    }
    > img {
      width: rem(104);
    }
  }

  &-comment {
    padding-top: use(30);
    padding-left: use(30);

    &.placeholder {
      padding: 0;

      img {
        display: block;
        height: rem(200);
        width: rem(286);
        margin: rem(137) auto rem(40) auto;
      }

      p {
        color: #999;
        font-size: rem(26);
        line-height: rem(37);
        text-align: center;
        margin-bottom: rem(65);
      }

      button {
        display: block;
        height: rem(50);
        width: rem(168);
        margin: 0 auto;
        text-align: center;
        line-height: rem(50);
        color: #fff;
        font-size: rem(28);
        border-radius: rem(6);
        border: 0;
        outline: 0;
        background-color: $globalColor;
      }
    }
  }

  &-inputer {
    position: fixed !important;
    bottom: 0;
    left: 0;
    &-holder {
      height: use(90);
    }
  }

  &-clock{
    position: fixed;
    bottom: use(80);
    right: use(40);
  }

  &-notice{
    padding: use(70) use(38) 0;
    box-sizing: border-box;
    text-align: left;
    h1{
      font-size: use(38);
      color: #444444;
      text-align: center;
      line-height: 1;
      margin: 0 auto use(45);
    }
    h5{
      font-size: use(30);
      font-weight: lighter;
      color: #555555;
      line-height: use(44);
      margin-bottom: use(30);
    }
    p{
      font-size: use(30);
      font-weight: lighter;
      color: #555555;
      line-height: use(44);
      margin-bottom: use(28);
      overflow: hidden;
    };
    p:first-child{
      font-weight: normal;
    };
    &-index{
      float: left;
      width: use(42);
      height: use(42);
      margin: use(3) use(18) use(44) 0;
      background: rgba(244,142,1,0.20);
      font-size: use(26);
      line-height: use(42);
      color: #F48E01;
      text-align: center;
      border-radius: 50%;
    }
    &-btn{
      font-size: use(34);
      color: #F48E01;
      text-align: center;
      line-height: use(90);
      margin-top: use(70);
      border-top: use(1) solid #E4E4E4;
    }

  }

  .bottom {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    text-align: center;
    padding: use(16) use(30);
    border-top: 1px solid #F3F4F5;

    &-tip {
      font-size: use(28);
      line-height: use(40);
      color: #333333;
      margin-bottom: use(20);
    }
  }
}

</style>
